"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HeroService() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section className="relative min-h-screen w-full overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1520072/img/data_constellation_abstract_background.png)]" aria-hidden="true" />

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-4 py-16 sm:px-6 lg:px-8">
        <div ref={ref} className={`glass-effect max-w-4xl w-full px-8 py-12 sm:px-12 sm:py-16 lg:px-16 lg:py-20 text-center transition-all duration-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
          {}
          <h1 className="text-foreground mb-4 font-bold leading-tight !text-[38px]">Données et Intelligence Artificielle</h1>

          {}
          <p className="text-muted-foreground mb-8 text-lg sm:text-xl lg:text-2xl leading-relaxed max-w-3xl mx-auto">Data platforms, stratégie AI, industrialisation, AI responsable.</p>

          {}
          <Link to="#contact">
            <Button size="lg" className="bg-primary hover:bg-primary-hover text-foreground-primary shadow-medium hover:shadow-strong hover:scale-[1.03] transition-all duration-[120ms] ease-in-out focus-ring px-8 py-6 text-base sm:text-lg font-semibold">Parlons Data / IA&nbsp;</Button>
          </Link>
        </div>
      </div>
    </section>;
}